// Typed wrappers for /api/v2/admin/matrix-stats — dashboard bar feed (Track 7).
import { apiClient } from "@/lib/api/client";
import { unwrap } from "@/lib/api/error";
import type { components } from "@generated/api/schema";

export type AggregatedMatrixStats =
  components["schemas"]["AggregatedMatrixStats"];
export type MatrixStatsSummary = components["schemas"]["MatrixStatsSummary"];
export type SourceRpmEntry = components["schemas"]["SourceRpmEntry"];
export type ErrorBreakdown = components["schemas"]["ErrorBreakdown"];

export type MatrixStatsPeriod = "1h" | "24h" | "7d" | "30d";

/** GET /api/v2/admin/matrix-stats?period=1h — aggregated Matrix broker stats. */
export async function fetchMatrixStats(
  period: MatrixStatsPeriod = "1h",
): Promise<AggregatedMatrixStats> {
  return unwrap(
    await apiClient.GET("/api/v2/admin/matrix-stats", {
      params: { query: { period } },
    }),
  );
}
